/* eslint-disable import/no-cycle */
import {decorate, observable} from 'mobx';
import {EntityStore} from './entityStore';
import {Api} from '../middleware/api';
import {ReportLog} from '../models/reportLog';
import i18n from '../i18n/i18n';

export class ReportLogStore extends EntityStore {
  reportLogs = [];

  constructor(rootStore) {
    super(rootStore, 'reportLogs', Api.reportLogs, ReportLog);
  }

  getDependencies() {
    return [
      {
        store: this.rootStore.operationStore,
        modelId: 'operationId',
      },
    ];
  }

  getByReportTypeIdAndOperationId(typeId, operationId) {
    return this.reportLogs.filter((reportLog) => reportLog.typeId === typeId && reportLog.operationId === operationId);
  }

  async bulkUpdate(reportLogs) {
    await this.api.bulkUpdate(reportLogs);
    this.addMessage({type: 'success', title: i18n.t('flashMessages.updateSuccess')},
      {skipNotification: false});
    this.clear();
  }
}

decorate(ReportLogStore, {
  reportLogs: observable,
});
